import { getActionTypesForService } from 'shared/utils/createServiceStore.js';
import { SOURCES_SERVICE_KEY } from './sourcesEnum.js';

export default getActionTypesForService(SOURCES_SERVICE_KEY);
